<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.carparkspace_delete"
          plain
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/led/parkledsetting';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { passageSelections } from '@/api/v4ward/park/passage/parkpassage';
export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      reWrite: false,
      selectionList: [],
      tempParkingLotId: '',
      option: {
        tip: false,
        tree: true,
        searchShow: true,
        searchMenuSpan: 6,
        height: 'auto',
        //calcHeight: 30,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        labelWidth: 180,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        align: 'center',
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            //dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            editDisabled: true,
            search: true,
            searchSpan: 5,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属通道',
            prop: 'passageName',
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '所属通道',
            prop: 'passageId',
            type: 'tree',
            hide: true,
            viewDisplay: false,
            search: false,
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择设备所属通道',
                trigger: 'change',
              },
            ],
            /*change: ({ value, column }) => {
              if (this.operateType == '') {
                return;
              }
              if (this.vdui.isEmpty(this.form.parkingLotId) && this.vdui.isNotEmpty(value)) {
                this.$message.warning('请先选择停车场');
              }

            },*/
          },

          {
            label: '指定音量大小时间',
            //prop: 'volumeTimeRange',
            prop: 'volumeTimeRange',
            //hide: true,
            maxlength: 20,
            width: 120,
            span: 24,
            valueFormat: 'HH:mm',
            format: 'HH:mm',
            viewDisplay: true,
            type: 'timerange',
            rules: [
              {
                required: true,
                message: '请输入指定音量时间段',
                trigger: 'change',
              },
              //{ pattern: /^\d{2}:\d{2}-\d{2}:\d{2}$/, message: '请按照HH:mm-HH:mm输入' },
            ],
          },

          {
            label: '时间内音量',
            prop: 'volumeByTime',
            value: 0,
            step: 10,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '时间外音量',
            prop: 'volumeOther',
            value: 0,
            step: 10,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '指定屏幕亮度时间',
            //prop: 'brightnessTimeRange',
            prop: 'brightnessTimeRange',
            maxlength: 20,
            type: 'timerange',
            //hide: true,
            width: 120,
            span: 24,
            valueFormat: 'HH:mm',
            format: 'HH:mm',
            //type: 'datetimerange',
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入LED屏幕亮度时间段',
                trigger: 'change',
              },
              //{ pattern: /^\d{2}:\d{2}-\d{2}:\d{2}$/, message: '请按照HH:mm-HH:mm输入' },
            ],
          },
          {
            label: '时间内亮度',
            prop: 'brightnessByTime',
            step: 10,
            value: 0,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '时间外亮度',
            prop: 'brightnessOther',
            step: 10,
            value: 0,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '播报速度',
            prop: 'voiceSpeed',
            step: 10,
            value: 0,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '滚动速度',
            prop: 'screenScrollSpeed',
            step: 10,
            value: 0,
            showInput: true,
            max: 100,
            type: 'slider',
          },
          {
            label: '文字方向',
            prop: 'contentDirection',
            maxlength: 20,
            type: 'radio',
            value: 1,
            dicData: [
              { label: '横向', value: 1 },
              { label: '纵向', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkledsetting_add, false),
        viewBtn: this.vaildData(this.permission.parkledsetting_view, false),
        delBtn: this.vaildData(this.permission.parkledsetting_delete, false),
        editBtn: this.vaildData(this.permission.parkledsetting_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.parkingLotId'() {
      this.form.passageId = '';
      let parkingLotIdTem = this.form.parkingLotId;
      if (this.vdui.isNotEmpty(parkingLotIdTem)) {
        this.loadPassageSelections(this.form.parkingLotId);
      }

    },

  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    loadPassageSelections(parkId) {
      if (typeof parkId === 'undefined') {
        return;
      }
      const column = this.findObject(this.option.column, 'passageId');
      passageSelections({ parkId: parkId }).then((res) => {
        if (this.operateType === 'add') {
          this.form.passageId = null;

        }

        column.dicData = res.data;
      });
    },

    rowSave(row, done, loading) {
      row.volumeTimeRange = row.volumeTimeRange.join('-');
      row.brightnessTimeRange = row.brightnessTimeRange.join('-');

      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    /*//自定义清空表单
    emptyForm() {
      this.form.passageId= '';
    },*/
    rowUpdate(row, index, done, loading) {
      row.volumeTimeRange = row.volumeTimeRange.join('-');
      row.brightnessTimeRange = row.brightnessTimeRange.join('-');
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          console.log(JSON.stringify(data));
          data.volumeTimeRange = data.volumeTimeRange.split('-');
          data.brightnessTimeRange = data.brightnessTimeRange.split('-');
          this.form = data;
        });
      } else if (type === 'add') {
        const column = this.findObject(this.option.column, 'passageId');
        column.dicData = [];
        this.form = {
          volumeTimeRange: ['07:00', '19:00'],
          brightnessTimeRange: ['07:00', '19:00'],

        };


      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
